import React from "react";
import { PushAdminUser, PushDevice } from "@myapp/contract";
import Loader from "../../../shared/ui/feedback/Loader/Loader";
import { useInfiniteScrollSentinel } from "../../../shared/hooks/useInfiniteScrollSentinel";
import { PushUserRow } from "./PushUserRow";

interface Props {
  users: PushAdminUser[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  onLoadMore: () => void;
  selected: ReadonlySet<number>;
  onToggle: (id: number) => void;
  onRevokeDevice: (user: PushAdminUser, device: PushDevice) => void;
  revokeDisabled?: boolean;
}

const SKELETON_ROWS = 6;

export const PushUserList: React.FC<Props> = ({
  users,
  isLoading,
  isFetchingNextPage,
  hasNextPage,
  onLoadMore,
  selected,
  onToggle,
  onRevokeDevice,
  revokeDisabled,
}) => {
  const sentinelRef = useInfiniteScrollSentinel({ hasMore: hasNextPage, onLoadMore });

  if (isLoading) {
    return (
      <div className="mt-3 flex flex-col gap-4" aria-hidden="true">
        {Array.from({ length: SKELETON_ROWS }, (_, index) => (
          <div key={index} className="h-[60px] animate-pulse rounded-[30px] bg-gray-100" />
        ))}
      </div>
    );
  }

  if (users.length === 0) {
    return (
      <p className="my-10 w-full text-center font-['PT_Sans'] text-[20px] font-bold text-primary">
        Keine Nutzer gefunden
      </p>
    );
  }

  return (
    // gap-4 between rows is the house rhythm (user-management uses the same ListItem cards).
    <div className="mt-3 flex flex-col gap-4">
      {users.map((user) => (
        <PushUserRow
          key={user.id}
          user={user}
          checked={selected.has(user.id)}
          onToggle={onToggle}
          onRevokeDevice={onRevokeDevice}
          revokeDisabled={revokeDisabled}
        />
      ))}
      <div ref={sentinelRef} />
      {isFetchingNextPage && (
        <div className="py-3">
          <Loader size="small" />
        </div>
      )}
    </div>
  );
};
